// extracted by mini-css-extract-plugin
export default {"articlesContainer":"Articles_articlesContainer__dia3l","header":"Articles_header__NCFQz"};